$('.step-by-step__item .collapse').on('show.bs.collapse',function () {
    $(this).closest('.step-by-step__item').addClass('step-by-step__item--open')
});

$('.step-by-step__item .collapse').on('hide.bs.collapse',function () {
    $(this).closest('.step-by-step__item').removeClass('step-by-step__item--open')
});